import React, { useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { ChevronLeft, ChevronRight, Quote } from 'lucide-react';
import { Button } from './ui/button';

const Testimonials = ({ data }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % data.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + data.length) % data.length);
  };

  return (
    <section id="testimonials" className="py-24 bg-[#0A0A0A]">
      <div className="container mx-auto px-6">
        <div 
          ref={ref}
          className={`max-w-4xl mx-auto transition-all duration-1000 ${
            inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-16 text-center">
            Client <span className="text-[#0066FF]">Testimonials</span>
          </h2>

          <div className="relative">
            {/* Quote icon */}
            <Quote className="absolute top-0 left-0 text-[#0066FF]/20 -z-0" size={80} />

            {/* Testimonial card */}
            <div className="bg-[#1A1A1A] rounded-2xl p-8 md:p-12 border border-white/10 relative z-10">
              <div className="flex flex-col items-center text-center space-y-6">
                {/* Avatar */}
                <img 
                  src={data[currentIndex].avatar} 
                  alt={data[currentIndex].name}
                  className="w-20 h-20 rounded-full object-cover border-4 border-[#0066FF]/30"
                />

                {/* Content */}
                <p className="text-lg md:text-xl text-gray-300 leading-relaxed italic">
                  "{data[currentIndex].content}"
                </p>

                {/* Author info */}
                <div>
                  <h4 className="text-xl font-bold text-white mb-1">
                    {data[currentIndex].name}
                  </h4>
                  <p className="text-[#0066FF] text-sm">
                    {data[currentIndex].role}
                  </p>
                </div>
              </div>
            </div>

            {/* Navigation */}
            <div className="flex justify-center gap-4 mt-8">
              <Button
                onClick={prevTestimonial}
                variant="outline"
                size="icon"
                className="bg-[#1A1A1A] border-white/10 text-white hover:bg-[#0066FF] hover:border-[#0066FF] rounded-full w-12 h-12 transition-all duration-300"
              >
                <ChevronLeft size={24} />
              </Button>
              <Button
                onClick={nextTestimonial}
                variant="outline"
                size="icon"
                className="bg-[#1A1A1A] border-white/10 text-white hover:bg-[#0066FF] hover:border-[#0066FF] rounded-full w-12 h-12 transition-all duration-300"
              >
                <ChevronRight size={24} />
              </Button>
            </div>

            {/* Dots indicator */}
            <div className="flex justify-center gap-2 mt-6">
              {data.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className={`w-2 h-2 rounded-full transition-all duration-300 ${
                    index === currentIndex 
                      ? 'bg-[#0066FF] w-8' 
                      : 'bg-white/20 hover:bg-white/40'
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
